window.WizardConfig = {

  general: {
    title: "Che cosa vorresti realizzare?",
    steps: [
      {
        id: "project",
        type: "cards",
        options: [
          {
            id: "bomboniere",
            title: "Bomboniere",
            description: "Per matrimoni, battesimi, comunioni e altre occasioni."
          },
          {
            id: "regali",
            title: "Regalo personalizzato",
            description: "Un regalo unico creato su misura."
          },
          {
            id: "legno",
            title: "Creazione in legno",
            description: "Oggetti in legno dipinti o incisi."
          },
          {
            id: "incisioni",
            title: "Incisione",
            description: "Su vetro, specchi e altri materiali."
          },
          {
            id: "disegni",
            title: "Disegno",
            description: "Illustrazioni e opere artistiche."
          },
          {
            id: "aiuto",
            title: "Non lo so ancora",
            description: "Ti aiuterò a trovare la soluzione migliore."
          }
        ]
      }
    ]
  },

  regali: {
    title: "Che tipo di regalo vorresti realizzare?",
    steps: [
        {
            id: "tipo_regalo",
            type: "cards",
            options: [
                { id: "compleanno", title: "Compleanno" },
                { id: "anniversario", title: "Anniversario" },
                { id: "nascita", title: "Nascita" },
                { id: "altro", title: "Altra occasione" }
            ]
        }
    ]
},

  bomboniere: {
    title: "Per quale occasione stai cercando delle bomboniere?",
    steps: [
      {
        id: "evento",
        type: "cards",
        options: [
          { id: "matrimonio", title: "Matrimonio" },
          { id: "battesimo", title: "Battesimo" },
          { id: "comunione", title: "Comunione" },
          { id: "cresima", title: "Cresima" },
          { id: "laurea", title: "Laurea" },
          { id: "anniversario", title: "Anniversario" },
          { id: "altro", title: "Altro" }
        ]
      }
    ]
  }

};

window.ProjectWizard = class {

    constructor(containerId) {

        this.container = document.getElementById(containerId);

        if (!this.container) return;

        this.state = {};

        this.currentStep = 0;

        // Legge il tipo di wizard dalla sezione Shopify
        this.wizardType = this.container.dataset.wizard || "general";

        // Carica la configurazione
        this.config = WizardConfig[this.wizardType];

        if (!this.config) {
            this.container.innerHTML = "<p>Configurazione Wizard non trovata.</p>";
            return;
        }

        this.steps = this.config.steps;

        this.render();

    }

    render() {

        const step = this.steps[this.currentStep];

        this.container.innerHTML = `

            <div class="pw-wrapper">

                <div class="pw-progress">
                    <div class="pw-progress-bar"></div>
                </div>

                <h2>${this.config.title}</h2>

                <div class="pw-options">

                    ${step.options.map(option => `

                        <button
                            class="pw-card"
                            data-id="${option.id}"
                        >

                            <h3>${option.title}</h3>

                            ${option.description ? `<p>${option.description}</p>` : ""}

                        </button>

                    `).join("")}

                </div>

            </div>

        `;

    }

}

function initProjectWizard() {

    setTimeout(() => {

        const container = document.getElementById("project-wizard");

        if (!container) {
            console.log("Wizard non trovato");
            return;
        }

        console.log("Wizard trovato:", container.dataset.wizard);

        new window.ProjectWizard("project-wizard");

    }, 100);

}

document.addEventListener("DOMContentLoaded", initProjectWizard);
document.addEventListener("shopify:section:load", initProjectWizard);